export const userDetailsHeaderText = {
  workforceStatus: "Workforce Status",
  telephone: "Contact Number",
  email: "Email",
  birthDate: "Date of Birth",
  completeAddress: "Address",
  diagnosis: "Diagnosis",
  preferences: "Preferences",
  attributes: "Attributes",
  levelOfCare: "Level Of Care",
  teamName: "Team Name",
  admitDate: "Admit Date",
  certificateEndDate: "Certificate End Date",
};

export const patientMetaData = {
  maritalStatus: "Marital Status",
  religion: "Religious Preference",
  "Mental & Physical Status": "Mental & Physical Status",
  "Family/Social History": "Family/Social History",
  "Code Status": "Code Status",
  "Patient Hobbies/Interest": "Patient Hobbies/Interest",
};

export const patientPreferenceFields = [
  { label: "How does this patient communicate?", key: "communicationStyle" },
  { label: "Engagement level and mental status", key: "energyLevel" },
  { label: "Languages spoken", key: "languages" },
  { label: "Communication considerations", key: "communicationNeeds" },
  { label: "Ambulatory Status", key: "ambulatoryStatus" },
  { label: "Activities & interests", key: "interests" },
  { label: "Pets in the home", key: "pets" },
  { label: "How are pets managed during visits?", key: "petManagement" },
  { label: "Smoking in the home", key: "smokingStatus" },
  { label: "Who is usually present during visits?", key: "othersPresent" },
  { label: "Branch of Service", key: "branchOfService" },
  { label: "Served in Conflict", key: "conflictServed" },
];

export const workforcePreferenceFields = [
  {
    label: "Patient types you’re comfortable with",
    key: "patientPreference",
  },
  { label: "Languages spoken", key: "languages" },
  { label: "Skills you can offer", key: "skills" },
  { label: "How do you feel about pets in the home?", key: "petComfort" },
  { label: "Any concerns or allergies to pets?", key: "petSensitivityOptions" },
  { label: "Smoking Tolerance", key: "smokingTolerance" },
  { label: "Branch of Service", key: "branchOfService" },
  { label: "Served in Conflict", key: "conflictServed" },
];

export const careGiverFields = [
  { label: "Name", isFullName: true },
  { label: "Contact Number", key: "telephone" },
  { label: "Relation", key: "caregiverRelation" },
  { label: "Address", key: "completeAddress" },
];

export const facilityFields = [
  { label: "Name", key: "facilityName" },
  { label: "Contact Number", key: "facilityPhone" },
  { label: "Type", key: "facilityTypeDescription" },
  { label: "Address", key: "facilityCompleteAddress" },
];

export const emergencyContactFields = [
  { label: "Name", isFullName: true },
  { label: "Contact Number", key: "telephone" },
  { label: "Relation", key: "relation" },
  { label: "Address", key: "completeAddress" },
];

export const statisticsFields = [
  { label: "Total Hours", key: "totalHours" },
  { label: "YTD", key: "yearlyHours" },
  { label: "MTD", key: "monthlyHours" },
  { label: "QTD", key: "quarterlyHours" },
  { label: "Years of Service", key: "yearsOfService" },
  { label: "Date of Last Activity", key: "lastActivityDate" },
];

export const mileageFields = [
  { label: "Total Mileage", key: "totalMileage" },
  { label: "Mileage By Year", key: "yearlyMileage", showSelect: true },
];
